import type {
  BlockSnapshotLeaf,
  FromSnapshotPayload,
  SnapshotNode,
  ToSnapshotPayload,
} from '@blocksuite/store';
import { BaseBlockTransformer } from '@blocksuite/store';

import type { ImageBlockProps } from './image-model.js';

export class ImageBlockTransformer extends BaseBlockTransformer<ImageBlockProps> {
  override async fromSnapshot(
    payload: FromSnapshotPayload
  ): Promise<SnapshotNode<ImageBlockProps>> {
    const snapshotRet = await super.fromSnapshot(payload);
    const sourceId = snapshotRet.props.sourceId;
    if (!payload.assets.isEmpty() && sourceId && !sourceId.startsWith('/')) {
      try {
        await payload.assets.writeToBlob(sourceId);
      } catch (err) {
        // Non-fatal: block model is still valid, blob can be synced later
        console.warn(
          `[ImageBlockTransformer] writeToBlob failed for sourceId=${sourceId}:`,
          err instanceof Error ? err.message : err
        );
      }
    }

    return snapshotRet;
  }

  override toSnapshot(
    snapshot: ToSnapshotPayload<ImageBlockProps>
  ): BlockSnapshotLeaf {
    const work = this.toSnapshotWork(snapshot);
    let next = work.next();
    while (!next.done) next = work.next();
    return next.value;
  }

  override *toSnapshotWork(
    snapshot: ToSnapshotPayload<ImageBlockProps>
  ): Generator<void, BlockSnapshotLeaf> {
    const snapshotRet = yield* super.toSnapshotWork(snapshot);
    const sourceId = snapshot.model.props.sourceId;
    if (sourceId) {
      const pathBlobIdMap = snapshot.assets.getPathBlobIdMap();
      pathBlobIdMap.set(snapshot.model.id, sourceId);
    }
    return snapshotRet;
  }
}
